const BaseService = require('@/services/BaseService')

const namespace = 'performance-reports-batches'

const findAll = (options, cb, errorCb) => {
  BaseService.get(namespace, options, cb, errorCb)
}

const queueBatch = (id, cb, errorCb) => {
  BaseService.get(namespace + '/' + id + '/queue', {}, cb, errorCb)
}

export {
  findAll,
  queueBatch
}
